import React from 'react';
import { IconProps } from './types';

export const WalletIcon: React.FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 12V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5z" />
    <path d="M21 12H16a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h5" />
    <line x1="8" y1="11" x2="8.01" y2="11" />
  </svg>
);
